/**
 * Changement de mot de passe impose (conception 3.3). Un compte cree ou
 * reinitialise par un administrateur recoit un mot de passe provisoire, a
 * remplacer avant tout autre ecran : l'API refuse le reste en 403
 * CHANGEMENT_MOT_DE_PASSE_REQUIS. On peut aussi se deconnecter d'ici.
 */
import { LogOut } from 'lucide-react';
import { useAuth } from '../lib/auth';
import { Bouton, useToast } from '../composants/ui';
import { CadreAuthentification } from '../composants/CadreAuthentification';
import { FormulaireMotDePasse } from '../composants/FormulaireMotDePasse';

export function PageMotDePasseImpose() {
  const { utilisateur, deconnexion } = useAuth();
  const toast = useToast();

  return (
    <CadreAuthentification
      titre="Choisissez votre mot de passe"
      sousTitre="Votre compte utilise un mot de passe provisoire. Remplacez-le par un mot de passe personnel pour continuer."
      pied={
        <div className="mt-8 flex flex-wrap items-center justify-between gap-2 border-t border-bordure pt-4 text-sm text-encre-discrete">
          <span className="min-w-0 truncate">{utilisateur?.email}</span>
          <Bouton variante="discret" taille="sm" icone={<LogOut aria-hidden="true" />} onClick={deconnexion}>
            Se déconnecter
          </Bouton>
        </div>
      }
    >
      <FormulaireMotDePasse
        libelleActuel="Mot de passe provisoire"
        libelleEnvoi="Enregistrer et continuer"
        identifiant={utilisateur?.email}
        pleineLargeur
        onSucces={() => toast.succes('Votre mot de passe est enregistré.')}
      />
    </CadreAuthentification>
  );
}
